import { Injectable } from '@angular/core';
import { ParentService } from '../../A2-utils/ParentClass/ParentService';
import { Router } from '@angular/router';
import {Http, Response} from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { constant } from '../../../app.constants';


@Injectable()
export class PayorFacilitiesService extends ParentService {

  constructor(private _http: Http, private route: Router) {
    super();
    // this.verifyToken(this._http, route);
  }
  getFacilitysParyor(id, isOrderingFacility?: boolean) {
    return this._http.get(constant.URL_PAYOR_FACILITY_2 + id + '?isOrderingFacility=' + isOrderingFacility, this.getHeader())
      .map(resp => resp.json());
  }
  postFacilitysParyor(body) {

    const bodyString = JSON.stringify(body);
    return this._http.post(constant.URL_PAYOR_FACILITIES, bodyString, this.headerPost())
      .map(( res: Response ) => res.json())
      .catch((error: any ) => Observable.throw(error.json()));
  }

  deleteFacilitysParyor(id) {
    return this._http.delete(constant.URL_PAYOR_FACILITIES + '/' + id, this.headerPost())
      .map((res: Response) => res.json() )
      .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/payors/payor-facilities/payor-facilities.service.ts